import type {Session} from '../types/session'
import {useIntentDetectionEnabled} from '../contexts/IntentDetectionEnabledContext'

export function useIntentDetection(session: Session | null | undefined = null) {
  const {isUsingIntentDetection} = useIntentDetectionEnabled()

  const isChatSession = isUsingIntentDetection && session?.event_type === 'chat'

  return {
    isChatSession,
    isUsingIntentDetection,
  }
}
